export default __webpack_public_path__ + "static/media/install.76e3a361.png";